import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { hideModal } from '../../managers/modal'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { UIButton } from 'components/ui/Button'
import { useState } from 'react'
import { showSuccessToast } from 'utils/toast'
import { useGetAreas } from 'api/areas'
import { openNewChat } from 'api/chats'
import { isUndefined } from 'lodash'
import { createValidationSchema, required } from 'utils/validations'
import clsx from 'clsx'
import { useGetBotMode } from 'hooks/useGetBotMode'
import styled from 'styled-components'
import { useGetSetting } from 'api/settings'
import { InputRadioExpandable } from 'components/ui/InputRadioExpandable'

export const ScrollDiv = styled.div<{ widgetColor?: string }>`
/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;

}
/* Handle */
::-webkit-scrollbar-thumb {
  border-radius:20px;
  background-clip: padding-box;
  background: ${(props) => props.widgetColor}; /* color of the scroll thumb */,
  border-radius: "20px"; /* roundness of the scroll thumb */,
  border: "none"; /* creates padding around scroll thumb */,
}
`

export const OpenChatModal = () => {
  const { t } = useTranslation()
  const { setting } = useGetSetting()
  const [loading, setLoading] = useState(false)
  const { isAppMode } = useGetBotMode()

  const { data } = useGetAreas()

  const { values, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      areaId: undefined,
    },
    validationSchema: createValidationSchema({
      areaId: required,
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      if (!values.areaId) return
      try {
        setLoading(true)
        await openNewChat({
          areaId: values.areaId,
        })
        setLoading(false)
        showSuccessToast(t('chatOpenedSuccess'))
        hideModal()
      } catch (e) {
        console.error({ e })
        setLoading(false)
      }
    },
  })

  const handleAreaSelection = (areaId: string) => {
    setFieldValue('areaId', areaId)
  }

  return (
    <div style={{ padding: 20 }}>
      <div className={'tw-flex tw-flex-row tw-items-center tw-justify-between'}>
        <div className={'tw-font-[800]'}>{t('needToOpenTicket')}</div>
        <div className={'tw-cursor-pointer'}>
          <FontAwesomeIcon icon={['far', 'times']} onClick={hideModal} />
        </div>
      </div>
      <div
        className={clsx(
          'tw-flex tw-flex-col tw-space-y-1 tw-mt-2',
          isAppMode ? 'modal-container-app' : `modal-container`,
        )}
      >
        <ScrollDiv widgetColor={setting?.secondaryColor} className={'tw-flex tw-flex-col tw-overflow-y-auto'}>
          {data.map((area) => (
            <div key={area._id} className={'tw-mt-2 tw-mr-2 tw-border-b-[1px]'}>
              <InputRadioExpandable
                key={area._id}
                value={area._id}
                label={area.name}
                disabled={area.numberOfAreaSources === 0}
                childrens={area.children}
                selectedValue={values.areaId}
                onChange={handleAreaSelection}
              />
            </div>
          ))}
        </ScrollDiv>
      </div>
      <div className={'tw-mt-6 tw-w-full'}>
        <UIButton
          className={'tw-w-full'}
          onClick={() => handleSubmit()}
          loading={loading}
          disabled={isUndefined(values.areaId)}
        >
          <span className={'tw-text-sm'}>{t('confirm')}</span>
        </UIButton>
      </div>
    </div>
  )
}
